import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { pricetagOutline, printOutline, saveOutline, trashOutline, walletOutline } from 'ionicons/icons';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import InfoTab from './info/InfoTab';
import InvoiceAmountTab from './invoice/InvoiceAmountTab';
import Select from 'react-select';
import { statusDropDownStyles } from '@ui/styles/status-dropdown-style';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { CreateInvoiceAsync, UpdateInvoiceAsync, deleteInvoiceByIdAsync, generateCostEstimatePdfAsync, generateInvoicePdfAsync, getAllInvoiceAmountsAsync, getAllInvoiceStatusAsync, getInvoiceByIdAsync } from '@application/features/invoices/invoiceThunk';
import InvoiceTabsHelpers from './invoiceHelpers';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { InvoiceStatus } from '@application/common/enums/invoice-status';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { IonIcon } from '@ionic/react';
import ModalPopup from '@ui/components/VnModal';
import InvoicePrintPreview from './InvoicePrintPreview';
import CostEstimatePrintPreview from '../CostEstimatePrintPreview';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { getWorkOrderByIdAsync, updateModulePermissionsStatusAsync, updateWorkOrderStatusById } from '@application/features/workorders/workorderThunk';
import { WorkorderStatus } from '@application/common/enums/workorder-status';
import { getDebtorByIdAsync } from '@application/features/debtors/debtorThunk';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import CostEstimateInvoiceAmountViewTable from '../CostEstimateInvoiceAmountViewTable';
import { TabNotification } from '@ui/components/VnTabNotification';
import { clearUpdateModulePermissionStatus, resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { useAsyncDebounce } from '@application/common/hooks/use-async-debounce';
import PersistentWarningMessage from '@ui/components/VnNotification/PersistantWarningMessage';
import PersistentInfoMessage from '@ui/components/VnNotification/PersistantInfoMessage';
import NotesTab from './notes/NotesTab';
import EmailEditorForm from '@ui/components/VnEmailEditor';
import { getEmailTemplateByNameAsync } from '@application/features/sendemail/sendemailThunk';
import { setInvoiceNotes, setInvoiceWorkOrderNumber } from '@application/features/invoices/invoiceSlice';
import { setSelectedQuotationItemsListForInvoice } from '@application/features/quotations/quotationSlice';
const InvoiceView = () => {
    const { invoiceStatusDropdown, InvoiceAmounts } = useAppSelector((state) => state.invoice);
    const { SelectedWorkorderMaterialsList } = useAppSelector((state) => state.material);
    const { debtor, updateDebtor } = useAppSelector((state) => state.debtors);
    const { workOrder } = useAppSelector((state) => state.workorder);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { formdata, setFormData, errors, handleFieldChange, handleCalendarChange, validateForm, infoTabErrorBorderColor, isNotesTabUnsaved, isInfoTabUnsaved, isInfoTabBold, isNotesTabBold } = InvoiceTabsHelpers();
    const [submitInvoice, setSubmitInvoice] = useState(false);
    const [disableRecord, setDisableRecord] = useState(false);
    const [isInvoiceDeleteConfirmationPopup, setInvoiceDeleteConfirmationPopup] = useState(false);
    const [filteredInvoiceAmountList, setFilteredInvoiceAmountList] = useState([]);
    const [isCostEstimateFormVisible, setIsCostEstimateFormVisible] = useState(false);
    const [isCostEstimateInvoiceAmountTableOpen, setIsCostEstimateInvoiceAmountTableOpen] = useState(false);
    const [isInvoicePrintFormVisible, setIsInvoicePrintFormVisible] = useState(false);
    const [invoicePrintData, setInvoicePrintData] = useState(formdata);
    const { moduleLocked, updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const [isInvoiceAmountTabBold, setIsInvoiceAmountTabBold] = useState(false);
    const [invoiceEmailTemplate, setInvoiceEmailTemplate] = useState('');
    const handleStatusDropdownChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            statusId: selectedOption.value
        }));
    };
    useEffect(() => {
        dispatch(getAllInvoiceStatusAsync());
    }, []);
    const { id } = useParams();
    VnDocumentTitle('Visser Fac-' + formdata.invoiceNumber);
    useEffect(() => {
        if (id) {
            dispatch(getInvoiceByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
                setInvoicePrintData(res);
                if (res.statusId == InvoiceStatus.Definitief) {
                    setDisableRecord(true);
                }
                if (res.invoiceNumber == null) {
                    setFormData((prevData) => ({
                        ...prevData,
                        invoiceNumber: id
                    }));
                }
                if (res.invoiceDate == null) {
                    const today = new Date(); // Assuming today's date as default
                    setFormData((prevData) => ({
                        ...prevData,
                        invoiceDate: today
                    }));
                }
                if (res.workOrderId) {
                    dispatch(getWorkOrderByIdAsync(res.workOrderId));
                }
                if (res.debtorId) {
                    dispatch(getDebtorByIdAsync(res.debtorId));
                }
            })
                .catch((error) => {
                console.error('Bad request.');
                navigate(`/admin/InvoicesList`);
            });
        }
    }, [id]);
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitInvoice) {
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                if (!disableRecord) {
                    const triggeredErrors = validateForm();
                    if (Object.values(triggeredErrors).every((error) => !error)) {
                        if (!id) {
                            dispatch(CreateInvoiceAsync(formdata))
                                .unwrap()
                                .then((res) => {
                                navigate(`/admin/InvoiceTabs/${res.id}`);
                                setFormData(res);
                                workOrderStatusUpdateOnInvoiceUpdate(res);
                                if (res.workOrderId) {
                                    dispatch(getWorkOrderByIdAsync(res.workOrderId));
                                }
                                if (res.debtorId) {
                                    dispatch(getDebtorByIdAsync(res.debtorId));
                                }
                            })
                                .catch((error) => {
                                console.error('Bad request.');
                            });
                        }
                        else {
                            //formdata.id = parseInt(id);
                            dispatch(UpdateInvoiceAsync(formdata))
                                .unwrap()
                                .then((res) => {
                                if (res.statusId == InvoiceStatus.Definitief) {
                                    setDisableRecord(true);
                                }
                                dispatch(getInvoiceByIdAsync(parseInt(id)))
                                    .unwrap()
                                    .then((res) => {
                                    setFormData(res);
                                    setInvoicePrintData(res);
                                })
                                    .catch((error) => {
                                    console.error('Bad request.');
                                    navigate(`/admin/InvoicesList`);
                                });
                                if (res.workOrderId) {
                                    dispatch(getWorkOrderByIdAsync(res.workOrderId));
                                }
                                if (res.debtorId) {
                                    dispatch(getDebtorByIdAsync(res.debtorId));
                                }
                            })
                                .catch((error) => {
                                console.error('Bad request.');
                            });
                        }
                    }
                }
                setSubmitInvoice(false);
            }
        }
    };
    const workOrderStatusUpdateOnInvoiceUpdate = (data) => {
        if (workOrder?.statusId !== WorkorderStatus.Gefactureerd && workOrder?.statusId !== WorkorderStatus.Vervallen) {
            if (data.statusId == InvoiceStatus.Concept) {
                dispatch(updateWorkOrderStatusById({
                    workOrderId: data.workOrderId,
                    statusId: WorkorderStatus.Nagecalculeerd
                }));
            }
            else if (data.statusId == InvoiceStatus.Definitief) {
                dispatch(updateWorkOrderStatusById({
                    workOrderId: data.workOrderId,
                    statusId: WorkorderStatus.Gefactureerd
                }));
            }
        }
    };
    const handleInvoiceDelete = () => {
        if (id) {
            dispatch(deleteInvoiceByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/InvoicesList'))
                .catch((error) => {
                setInvoiceDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelInvoiceDeleteClicked = () => {
        setInvoiceDeleteConfirmationPopup(false);
    };
    const handleCostEstimatePrintPreview = (filterInvoiceAmountList) => {
        setIsCostEstimateFormVisible(true);
        setIsCostEstimateInvoiceAmountTableOpen(false);
        setFilteredInvoiceAmountList(filterInvoiceAmountList);
    };
    //-------------------------Module Lock Functionality-------------------//
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Facturen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    const checkModulelockandTimeTriggerForFields = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            // Return false immediately to allow the user to continue working
            var result = false;
            // Call the debounced API function
            debouncedCheckModuleLockApiCall()
                .then((res) => {
                if (res.isModuleAlreadyLocked) {
                    // Notify the user if the module is locked
                    // setIsPersistantInfoCustomToasterOpen(res.isModuleAlreadyLocked);
                    dispatch(setModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
                else {
                    dispatch(unsetModuleLock());
                    result = res.isModuleAlreadyLocked;
                }
            })
                .catch(() => {
                dispatch(unsetModuleLock());
                // Handle any errors if needed
            });
            return result; // Allow user to continue working immediately
        }
        return false;
    };
    const checkModuleLockApiCall = async () => {
        const moduleLockRequestData = {
            moduleId: VisserModule.Facturen,
            recordId: parseInt(id)
        };
        return await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
    };
    const debouncedCheckModuleLockApiCall = useAsyncDebounce(checkModuleLockApiCall, parseInt(process.env.REACT_APP_DEBOUNCE_TIME_FOR_MODULE_LOCK_API));
    useEffect(() => {
        // Cleanup function that runs when the component unmounts
        return () => {
            dispatch(resetTimer());
            dispatch(unsetModuleLock());
            dispatch(clearUpdateModulePermissionStatus());
        };
    }, [resetTimer]);
    useEffect(() => {
        dispatch(unsetModuleLock());
        // checkModulelock();
    }, []);
    const handleFieldChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        if (moduleLockStatus == false) {
            handleFieldChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleFieldChangeWrapperForText = async (fieldName, value) => {
        handleFieldChange(fieldName, value); // Call the original handleFieldChange
        var moduleLockStatus = await checkModulelockandTimeTriggerForFields();
        // if (moduleLockStatus == false) {
        //     handleFieldChange(fieldName, value); // Call the original handleFieldChange
        // }
    };
    const handleCalendarChangeWrapper = async (fieldName, value) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            handleCalendarChange(fieldName, value); // Call the original handleFieldChange
        }
    };
    const handleInvoiceAmountTabBold = (state) => {
        setIsInvoiceAmountTabBold(state);
    };
    //---------------- send Email
    const [isInvoiceSentAsEmailViewOpen, setIsInvoiceSentAsEmailViewOpen] = useState(false);
    const [invoicDocument, setInvoiceDocument] = useState(null);
    const handelQuotationSentAsEmailWithAttachmentPopup = () => {
        if (id && !isNaN(parseInt(id))) {
            dispatch(getAllInvoiceAmountsAsync(parseInt(id)));
            dispatch(getEmailTemplateByNameAsync('SendInvoiceTemplate'))
                .unwrap()
                .then((res) => {
                if (res.body) {
                    setInvoiceEmailTemplate(res.body);
                    setIsInvoicePrintFormVisible(false);
                    setIsInvoiceSentAsEmailViewOpen(true);
                }
            })
                .catch((error) => { });
            if (InvoiceAmounts) {
                const total = InvoiceAmounts.filter((x) => x.isAmountHidden == true).reduce((acc, InvoiceAmount) => {
                    if (InvoiceAmount.isAmountHidden) {
                        return acc + InvoiceAmount.quantity * InvoiceAmount.price;
                    }
                    return acc + InvoiceAmount.quantity * InvoiceAmount.price;
                }, 0);
                dispatch(getWorkOrderByIdAsync(formdata.workOrderId))
                    .unwrap()
                    .then((res) => {
                    var materials = {
                        objectClientReference: res?.objectClientReference,
                        contactPerson: res?.contactPerson,
                        invoiceNumber: invoicePrintData?.invoiceNumber,
                        address: updateDebtor?.address,
                        postalCode: updateDebtor?.postalCode,
                        city: updateDebtor?.city,
                        country: updateDebtor?.country,
                        name: updateDebtor?.name,
                        invoiceDate: invoicePrintData?.invoiceDate,
                        invoiceAmounts: InvoiceAmounts,
                        totalAmount: total,
                        debtorId: updateDebtor?.id
                    };
                    dispatch(generateInvoicePdfAsync(materials))
                        .unwrap()
                        .then((res) => {
                        setInvoiceDocument('data:application/pdf;base64,' + res);
                    });
                })
                    .catch((error) => {
                    console.error('Bad request.');
                });
            }
        }
    };
    const handelQuotationSentAsEmailClose = () => {
        setIsInvoiceSentAsEmailViewOpen(false);
        setIsInvoicePrintFormVisible(true);
    };
    //---------------- send Email of Cost Estimation
    const [isCostEstimationSentAsEmailViewOpen, setIsCostEstimationSentAsEmailViewOpen] = useState(false);
    const [costEstimationDocument, setCostEstimationDocument] = useState(null);
    const handelSendCostEstimationPDfInEmailPopup = () => {
        if (id && !isNaN(parseInt(id))) {
            setIsCostEstimationSentAsEmailViewOpen(true);
            setIsCostEstimateFormVisible(false);
            dispatch(getAllInvoiceAmountsAsync(parseInt(id)));
            if (InvoiceAmounts) {
                dispatch(getWorkOrderByIdAsync(formdata.workOrderId))
                    .unwrap()
                    .then((res) => {
                    const generateCostEstimatePdfData = {
                        objectClientReference: res?.objectClientReference,
                        workorderNumber: res.workOrderNumber,
                        name: debtor?.name,
                        address: debtor?.address,
                        postalCode: debtor?.postalCode,
                        city: debtor?.city,
                        invoiceAmounts: InvoiceAmounts,
                        invoiceAmountList: filteredInvoiceAmountList,
                        debtorId: debtor?.id
                    };
                    dispatch(generateCostEstimatePdfAsync(generateCostEstimatePdfData))
                        .unwrap()
                        .then((res) => {
                        setCostEstimationDocument('data:application/pdf;base64,' + res);
                    });
                })
                    .catch((error) => {
                    console.error('Bad request.');
                });
            }
        }
    };
    const handelSendCostEstimationPDfInEmailPopupClose = () => {
        setIsCostEstimationSentAsEmailViewOpen(false);
        setIsCostEstimateFormVisible(true);
    };
    //---------------- send Email
    const handleEmailSendSuccessForInvoice = (value) => {
        if (value) {
            handelQuotationSentAsEmailClose();
            dispatch(updateWorkOrderStatusById({
                workOrderId: invoicePrintData.workOrderId,
                statusId: WorkorderStatus.Gefactureerd
            }))
                .unwrap()
                .then(() => { })
                .catch(() => { });
        }
    };
    const handleEmailSendSuccessForCostEstimate = (value) => {
        handelSendCostEstimationPDfInEmailPopupClose();
    };
    const handleInvoiceOnModuleLockReset = (value) => {
        if (value) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => !error)) {
                dispatch(UpdateInvoiceAsync(formdata));
            }
        }
    };
    //---------For Inovice view from workorder----------------
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const dataKey = searchParams.get('dataKey');
        if (dataKey) {
            const savedData = localStorage.getItem(dataKey);
            if (savedData) {
                const { workOrderData, quotationNotes, quotationAmounts } = JSON.parse(savedData);
                handleFieldChange('workOrderId', workOrderData.label);
                handleFieldChange('workorderNumber', workOrderData.value);
                // Initialize invoice with stored data
                dispatch(setInvoiceWorkOrderNumber(workOrderData));
                dispatch(setInvoiceNotes(quotationNotes));
                dispatch(setSelectedQuotationItemsListForInvoice(quotationAmounts));
                // Cleanup
                localStorage.removeItem(dataKey);
            }
        }
    }, [searchParams, dispatch]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { className: 'ml-1 mb-1', children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Facturen" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/InvoicesList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: walletOutline, className: 'vn-breadcrum-icon wallet-icon-flipped' }) }), "Facturen"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formdata.invoiceNumber }), formdata.id ? (_jsxs(_Fragment, { children: [_jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: debtor?.name }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: workOrder?.description })] })) : ('')] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', isDisabled: moduleLocked ||
                                                    (handleRolePermission(Permission.FACTUREN, PermissionType.Delete) && id && !disableRecord
                                                        ? false
                                                        : true), type: 'button', customIconClassName: 'vn-action-button-icon', onClick: async () => {
                                                    var moduleLockStatus = await checkModulelock();
                                                    if (moduleLockStatus == false) {
                                                        setInvoiceDeleteConfirmationPopup(true);
                                                    }
                                                } }), _jsx(VnButton, { icon: printOutline, customClassName: 'vn-action-button-cancel', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon', onClick: () => {
                                                    setIsInvoicePrintFormVisible(true);
                                                }, isDisabled: moduleLocked || (handleRolePermission(Permission.FACTUREN, PermissionType.Read) && id ? false : true), type: 'button' }), formdata.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitInvoice(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: moduleLocked ||
                                                    (handleRolePermission(Permission.FACTUREN, PermissionType.Update) && id && !disableRecord
                                                        ? false
                                                        : true) })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                    setSubmitInvoice(true);
                                                }, customIconClassName: 'vn-action-button-icon', isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Create) || disableRecord }))] })] }), _jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col-sm-8 vn-workorder-status-container', children: _jsx(VnButton, { customClassName: 'vn-header-buttons ml-1 vn-workorder-topbar-button', icon: pricetagOutline, mode: 'primary', type: 'button', isDisabled: handleRolePermission(Permission.FACTUREN, PermissionType.Read) && formdata.id && !disableRecord
                                                ? false
                                                : true, onClick: async () => {
                                                var moduleLockStatus = await checkModulelock();
                                                if (moduleLockStatus == false) {
                                                    setIsCostEstimateInvoiceAmountTableOpen(true);
                                                }
                                            }, children: "Kostenopgave" }) }), _jsx("div", { className: 'col-sm-4 vn-status-col', style: { display: 'flex', justifyContent: 'end', flexWrap: 'wrap' }, children: _jsxs("div", { style: { display: 'flex' }, children: [_jsx("label", { className: 'vn-status-label', children: "Status:" }), _jsx(Select, { styles: statusDropDownStyles, value: invoiceStatusDropdown?.find((option) => option.value === formdata.statusId), options: invoiceStatusDropdown, isSearchable: false, onChange: handleStatusDropdownChange, isDisabled: disableRecord })] }) })] }), _jsxs(Tabs, { className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                             ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(InfoTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, disableRecord: disableRecord }) }), _jsx(Tab, { eventKey: 'InvoiceTab', title: 'Factuur', tabClassName: `${isInvoiceAmountTabBold ? 'has-data' : ''}
                            `, children: _jsx(InvoiceAmountTab, { isDisabled: disableRecord, formData: formdata, handleFieldChange: handleFieldChangeWrapperForText, isInvoiceAmountTabBold: handleInvoiceAmountTabBold }) }), _jsx(Tab, { eventKey: 'NotitiesTab', title: TabNotification('Notities', false, isNotesTabUnsaved), tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChangeWrapperForText, onCalendarChange: handleCalendarChangeWrapper, disableRecord: disableRecord }) })] })] }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de factuur worden permanent verwijderd. Weet u zeker dat u de factuur wilt verwijderen?', onCancel: () => onCancelInvoiceDeleteClicked(), onConfirm: () => handleInvoiceDelete(), onOpen: isInvoiceDeleteConfirmationPopup }), _jsx(ModalPopup, { title: 'Factuur', content: _jsx(InvoicePrintPreview, { onClose: () => setIsInvoicePrintFormVisible(false), invoiceData: invoicePrintData, handelInvoiceSentAsEmailWithAttachmentPopup: handelQuotationSentAsEmailWithAttachmentPopup }), onOpen: isInvoicePrintFormVisible, onClose: () => setIsInvoicePrintFormVisible(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Kostenopgave', content: _jsx(CostEstimatePrintPreview, { onClose: () => setIsCostEstimateFormVisible(false), invoice: invoicePrintData, invoiceAmountList: filteredInvoiceAmountList, handelSendCostEstimationPDfInEmailPopup: handelSendCostEstimationPDfInEmailPopup }), onOpen: isCostEstimateFormVisible, onClose: () => setIsCostEstimateFormVisible(false), modalWidth: 'xl' }), _jsx(ModalPopup, { title: 'Selecteer Regels', content: _jsx(CostEstimateInvoiceAmountViewTable, { onClose: () => setIsCostEstimateInvoiceAmountTableOpen(false), invoice: formdata, costEstimatePrintPreview: handleCostEstimatePrintPreview }), onOpen: isCostEstimateInvoiceAmountTableOpen, onClose: () => setIsCostEstimateInvoiceAmountTableOpen(false), modalWidth: 'xl' })] }), invoiceEmailTemplate && invoiceEmailTemplate.trim() !== '' && (_jsx(ModalPopup, { title: 'Verzend e-mail', content: _jsx(EmailEditorForm, { onClose: handelQuotationSentAsEmailClose, isAttachmentAdded: true, emailWithAttachmentDto: {
                        attachment: invoicDocument,
                        attachmentName: 'Facturen-' +
                            formdata.invoiceNumber +
                            '-' +
                            String(new Date().getDate()).padStart(2, '0') +
                            String(new Date().getMonth() + 1).padStart(2, '0') +
                            new Date().getFullYear() +
                            '.pdf',
                        to: formdata.debtorInvoiceEmail ?? '',
                        subject: '',
                        emailBody: invoiceEmailTemplate ?? ''
                    }, OnEmailSend: handleEmailSendSuccessForInvoice }), onOpen: isInvoiceSentAsEmailViewOpen, onClose: handelQuotationSentAsEmailClose, modalWidth: 'lg' })), _jsx(ModalPopup, { title: 'Verzend e-mail', content: _jsx(EmailEditorForm, { onClose: handelSendCostEstimationPDfInEmailPopupClose, isAttachmentAdded: true, emailWithAttachmentDto: {
                        attachment: costEstimationDocument,
                        attachmentName: 'Kostenopgave-' +
                            formdata.invoiceNumber +
                            '-' +
                            String(new Date().getDate()).padStart(2, '0') +
                            String(new Date().getMonth() + 1).padStart(2, '0') +
                            new Date().getFullYear() +
                            '.pdf',
                        to: formdata.debtorEmail ?? '',
                        subject: '',
                        emailBody: ''
                    }, OnEmailSend: handleEmailSendSuccessForCostEstimate }), onOpen: isCostEstimationSentAsEmailViewOpen, onClose: handelSendCostEstimationPDfInEmailPopupClose, modalWidth: 'lg' }), updateModulePermissionStatus && !moduleLocked ? (_jsx(PersistentWarningMessage, { recordId: formdata.id, moduleId: VisserModule.Facturen, handleIsModuleLockReset: handleInvoiceOnModuleLockReset })) : (''), moduleLocked ? _jsx(PersistentInfoMessage, { recordId: formdata.id, moduleId: VisserModule.Facturen }) : ''] }));
};
export default InvoiceView;
